<template>
  <div :class="['form-control w-full', layout]">
    <label :class="['label', labelLayout]" :style="{ width: labelWidth }" v-if="label" :for="name">
      <span class="label-text">{{ label }}<span v-if="required" class="text-red-500">*</span>: </span>
    </label>
    <input
      v-if="type === 'checkbox'"
      type="checkbox"
      :checked="modelValue"
      @input="(event) => $emit('update:modelValue', event.target.checked)"
      class="checkbox">
    <component
      v-else-if="mask"
      v-mask="mask"
      :is="type === 'textarea' ? type : 'input'"
      :readonly="readonly"
      :value="value1"
      @input="handleInput"
      :name="name"
      :autofocus="autofocus"
      :type="type"
      :placeholder="placeholder"
      :step="step"
      :class="[
        'bg-base-100',
        type === 'textarea' ? 'textarea textarea-bordered' : 'input input-bordered',
        inputLayout,
        type === 'textarea' ? {
          'textarea-error': error
        } :  {
          'select-error': error
        }
      ]"
      :maxlength="maxlength"
      :rows="rows"
    />
    <component
      v-else
      :is="type === 'textarea' ? type : 'input'"
      :readonly="readonly"
      :value="value1"
      @input="handleInput"
      :name="name"
      :autofocus="autofocus"
      :type="type"
      :placeholder="placeholder"
      :step="step"
      :class="[
        'bg-base-100',
        type === 'textarea' ? 'textarea textarea-bordered' : 'input input-bordered',
        inputLayout,
        type === 'textarea' ? {
          'textarea-error': error
        } :  {
          'select-error': error
        }
      ]"
      :maxlength="maxlength"
      :rows="rows"
    />
    <div class="label-text text-right pt-2" v-if="maxlength">{{ modelValue.length }} / {{ maxlength }}</div>
    <slot />
  </div>
</template>
<script>
import { mask } from 'vue-the-mask'
export default {
  directives: { mask },
  props: {
    modelValue: { type: [String, Number, Boolean], default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String },
    type: { type: String, default: 'text' },
    step: { type: String, default: '1' },
    autofocus: { type: Boolean },
    name: { type: String },
    readonly: { type: Boolean },
    lowercase: { type: Boolean },
    trim: { type: Boolean },
    currency: { type: Boolean },
    error: { type: Boolean, default: false },
    rows: { type: String, default: '5' },
    mask: { type: [String, Array], default: null },
    required: { type: Boolean, default: false },
    maxlength: { type: Number }
  },
  inject: {
    labelPosition: {
      type: String,
      default: 'top'
    },
    labelWidth: {
      type: String,
      default: 'auto'
    }
  },
  computed: {
    layout () {
      if (this.labelPosition === 'left') {
        return 'flex flex-row space-x-2'
      } else {
        return ''
      }
    },
    labelLayout () {
      if (this.labelPosition === 'left') {
        return 'p-0 flex justify-end items-center text-right'
      } else {
        return ''
      }
    },
    inputLayout () {
      if (this.labelPosition === 'left') {
        return 'flex-1'
      } else {
        return 'w-full'
      }
    },
    value1: {
      get () {
        if (this.currency) {
          return '₮ ' + String(this.modelValue).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return this.modelValue
      }
    }
  },
  methods: {
    handleInput (e) {
      if (this.trim) {
        e.target.value = e.target.value.trim()
      }
      if (this.lowercase) {
        e.target.value = e.target.value.toLowerCase()
      } else if (this.uppercase) {
        e.target.value = e.target.value.toUpperCase()
      }
      if (this.currency) {
        const checkValue = e.target.value.replace(/,/g, '').replace('₮', '')
        if (isNaN(checkValue)) {
          e.target.value = this.value1
        } else {
          this.$emit('update:modelValue', Number(checkValue))
        }
      } else {
        this.$emit('update:modelValue', e.target.value)
      }
      e.preventDefault()
    }
  }
}
</script>
